
/**
* Licensed Materials - Property of IBM
* IBM Cognos Products: ba-dashboard-livewidget
* (C) Copyright IBM Corp. 2018, 2021
* US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
*/
define({
	'dataSource': 'Veri kaynağı',
	'dataSourceId': 'Tanıtıcı',
	'dataSourceType': 'Tip',
	'dataSourceName': 'Ad',
	'dataSourcePath': 'Yol',
	'showInfoForAll': 'Tüm görselleştirmeler için süreyi göster',
	'hideInfoForAll': 'Tüm görselleştirmeler için süreyi gizle',
	'showPerformanceDetails': 'Performans ayrıntılarını dahil etmek için tüm pencere gereçlerini yeniden çalıştır',
	'slotMappingField': 'Yuva eşlemeleri',
	'slotDataMapping': 'Eşleme',
	'slotID': 'Tanıtıcı',
	'slotCaption': 'Başlık',
	'slotMandatory': 'Zorunlu',
	'slotIsMandatory': 'Evet',
	'slotIsNotMandatory': 'Hayır',
	'infoNotAvailable': 'Yok',
	'performanceSection': 'Performans',
	'durationField': 'Süre',
	'singleQueryTime': 'Sunucu sorgusu (ms)',
	'multipleQueryTime': 'Sunucu sorgusu %{name} (ms)',
	'liveWidgetTotalTime': 'Toplam (ms)',
	'renderTimeNotAvailable': 'Kullanılamıyor',
	'renderInProgress': '(devam ediyor)',
	'interactToTriggerQuery': 'Bir sorguyu tetiklemek için gereçle etkileşimli çalış',
	'fetchQuery': 'Sorguyu Getir',
	'showSQLMDX': 'SQL/MDX\'i Göster',
	'SQLMDX': 'SQL/MDX',
	'queryInfo': 'Sorgu Bilgileri',
	'queryInfoNotAvailable': 'Sorgu bilgileri kullanılamıyor',
	'query': 'Sorgu',
	'copy': 'Kopyala',
	'close': 'Kapat'
});
